import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';

const StyledDiv = styled.div.withConfig({
  componentId: "sg1510__sc-oz7yv0-0"
})(["padding:", " 0;padding-left:1rem;position:relative;&::after{background-color:", ";border-radius:2px;bottom:", ";content:'';left:0;position:absolute;top:", ";width:4px;}"], tokens.space.xxs, tokens.color.primary, tokens.space.xxs, tokens.space.xxs);
const HelpContent = _ref => {
  let {
    children,
    className,
    id
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledDiv, {
    className: className,
    id: id
  }, children);
};
HelpContent.displayName = 'HelpContent';
HelpContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string
};

export { HelpContent };
